import { Dialog } from '@material-ui/core';
import { Box } from 'app/components/basic/Wrappers/Box';

export interface PopupImportExportDialogProps {
  open: boolean;
  content: React.ReactNode;
}
export function PopupImportExportDialog(props: PopupImportExportDialogProps) {
  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      open={props.open}
      aria-labelledby={'exportimport-dialog-popup'}
      fullScreen={true}
      fullWidth={true}
    >
      <Box
        style={{
          width: '100%',
          height: '100%',
          padding: '32px',
          backgroundColor: '#fcfcfd',
        }}
      >
        {props.content}
      </Box>
    </Dialog>
  );
}
